<script>
    import { onMount } from 'svelte';

    export let sceneType;
    export let event = {};

    const dateTimeOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };


    $: eventDateTime = new Date(event.time);


    onMount (() => {
        console.log('scene event: ',event);
    
    });
</script>
<section id="scene-container">
    {#if sceneType==='live'}
        <div class='rc'>
            otech.
            <br>events
            <!-- {info.line1}
            <br/>{info.line2}     -->
        </div>
        <div class='lb'>
            <div>
                <img src={event.groupPhotoLink} alt="meetup group logo" />
            </div>
            <div>
                <div class="event-name">{event.name}</div>
                <div>{event.group.name}</div>
                <div>@{event.venue.name}</div>
                <div>{eventDateTime.toLocaleDateString(undefined,dateTimeOptions)}, {eventDateTime.toLocaleTimeString()}</div>
            </div>
        </div>

    {:else }
        <div class='lc'>
            <img src={event.groupPhotoLink} alt="meetup group logo" />
            <div class="event-name">{event.name}</div>
            <div>{event.group.name}</div>
            <div>@{event.venue.name}</div>
            <div>{eventDateTime.toLocaleDateString(undefined,dateTimeOptions)}, {eventDateTime.toLocaleTimeString()}</div>
            <div class="scene-type">{sceneType}</div>
            <div>more info: otech.events</div>
        </div>
    {/if}

</section>


<style>
    #scene-container {
        display: grid;
        width: 100%;
        height: 100%;
        font-size: 20px;
        background-color: white;
        grid-template: "lt mt rt"
                       "lc mc rc"
                       "lb mb rb"
    }

    .lt {
        grid-area: lt;
    }
    .mt {
        grid-area: mt;
    }
    .rt {
        grid-area: rt;
    }
    .lc {
        grid-area: lc;
        font-family: sans-serif;
        text-align: center;
        justify-self: start;
        align-self: center;
        line-height: 28px;
    }
    .mc {
        grid-area: mc;
        font-family: sans-serif;
        text-align: center;
        justify-self: center;
        align-self: center;
        line-height: 28px;
    }
    .rc {
        grid-area: rc;
        font-size: 48px;
        font-family: sans-serif;
        text-align: center;
        justify-self: end;
        align-self: center;
        line-height: 28px;
    }
    .lb {
        grid-area: lb;
        display: flex;
        font-family: sans-serif;
        text-align: center;
        justify-self: start;
        align-self: end;
        align-items: center;
        line-height: 28px;
    }
    .mb {
        grid-area: mb;
    }
    .rb {
        grid-area: rb;
    }

    img {
        width: 100px;
        height: auto;
    }

    .event-name {
        font-size: 30px;
    }

    .scene-type {
        font-size: 30px;
    }

</style>